'use strict';

var React = require('react');
var _ = require('underscore');
var GlobalConst = require('../../types/GlobalConst');

var CustomRect = React.createClass({
  propTypes: {
    backgroundColor: React.PropTypes.string,
    border : React.PropTypes.string,
    borderStyle: React.PropTypes.string,
    borderLeftStyle: React.PropTypes.string,
    borderTopStyle: React.PropTypes.string,
    borderRightStyle: React.PropTypes.string,
    borderBottomStyle: React.PropTypes.string,
    borderColor: React.PropTypes.string,
    borderRadius: React.PropTypes.number,
    borderWidth : React.PropTypes.number,
    width: React.PropTypes.oneOfType([React.PropTypes.number,React.PropTypes.string]),
    height: React.PropTypes.oneOfType([React.PropTypes.number,React.PropTypes.string]),
    left: React.PropTypes.oneOfType([React.PropTypes.number,React.PropTypes.string]),
    top: React.PropTypes.oneOfType([React.PropTypes.number,React.PropTypes.string]),
    position: React.PropTypes.string,
    style : React.PropTypes.object,
    onClick : React.PropTypes.func
  },

  initStyle: function () {
    var style = this.props.style;
    if(!style) {
      style = {
        left: 0,
        top: 0,
        width: '100%',
        height: '100%'
      };
    }
    var props = this.props;
    if(_.isUndefined(style.width)){
      style.width = '100%';
    }
    if(_.isUndefined(style.height)){
      style.height = '100%';
    }
    if (props.left) {
      style.left = props.left;
    }
    if (props.top) {
      style.top = props.top;
    }
    if (props.width) {
      style.width = props.width;
    }
    if (props.height) {
      style.height = props.height;
    }
    style.backgroundColor = style.backgroundColor || props.backgroundColor || 'transparent';
    if(!_.isUndefined(props.border)){
      style.border = props.border;
    }
    if(!_.isUndefined(props.borderStyle)){
      style.borderStyle = props.borderStyle;
    }
    if(!_.isUndefined(props.borderLeftStyle)){
      style.borderLeftStyle = props.borderLeftStyle;
    }
    if(!_.isUndefined(props.borderTopStyle)){
      style.borderTopStyle = props.borderTopStyle;
    }
    if(!_.isUndefined(props.borderRightStyle)){
      style.borderRightStyle = props.borderRightStyle;
    }
    if(!_.isUndefined(props.borderBottomStyle)){
      style.borderBottomStyle = props.borderBottomStyle;
    }
    if(!_.isUndefined(props.borderColor)) {
      style.borderColor = props.borderColor;
    }else{
      if(!style.border)
        style.borderColor = style.borderColor || GlobalConst.GLOBAL_COLOR.DEFAULT_BORDER_COLOR;
    }
    if(!_.isUndefined(props.borderWidth)){
      style.borderWidth = props.borderWidth
    }else{
      style.borderWidth = style.borderWidth || 1;
    }
    if(!_.isUndefined(props.borderRadius)){
      style.borderRadius = props.borderRadius
    }else{
      style.borderRadius = style.borderRadius || 0;
    }
    style.position = style.position || props.position || 'absolute';
    style.textDecoration = style.textDecoration || props.textDecoration || 'inherit';
    style.boxSizing = style.boxSizing || props.boxSizing || 'border-box';


    if(this.props.showSeparator){
      style.borderBottom = '1px solid ' + this.props.separatorColor
    }

    return style;
  },
  render: function () {
    var style = this.initStyle();
    return (
      <div className={this.props.className || 'custom_rect'}
           style={style}
           onClick={this.props.onClick}>
        {this.props.children}
      </div>
    );
  }
});

module.exports = CustomRect;


// WEBPACK FOOTER //
// ./src/views/common/CustomRect.jsx